// removed by extract-text-webpack-plugin
module.exports = {"headerWrapper":"headerWrapper--2UXKN","title":"title--BCcCg","metaContainer":"metaContainer--21mEX"};